<template>
  <div class="main-container">
    <div class="main-border">
      <div class="line-panel">
        <el-image :src="cpsConfig.logoUrlAlpha" lazy style="width: 100px; height: 100px;"></el-image>
        <div>{{ cpsConfig.appName }}管理后台</div>
      </div>
      <div class="form-border">
        <el-form :model="ruleForm" label-position="top" status-icon :rules="rules" ref="ruleForm"
                 label-width="4rem" style="width: 100%">
          <el-form-item label="账号" prop="account">
            <el-input type="text" v-model="ruleForm.account" autocomplete="off" placeholder="请输入账号"
                      @keyup.enter.native="submitForm('ruleForm')"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码"
                      @keyup.enter.native="submitForm('ruleForm')"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:0;">
            <el-button :loading="loginLoading" size="medium" class="login-button"
                       @click="submitForm('ruleForm')">立即登录
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="text" size="medium" class="reset-button" @click="resetVisible=true">忘记密码</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div>
      <el-dialog title="手机号验证" :visible.sync="dialogFormVisible" :center=true width="400px" :show-close=false
                 :close-on-click-modal=false :close-on-press-escape="false">
        <el-form :model="ruleForm" class="demo-ruleForm">
          <el-form-item label="手机号" label-width="100px">
            <el-input v-model="ruleForm.phone" disabled="disabled" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="验证码" label-width="100px">
            <el-input v-model="ruleForm.checkCode" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="" label-width="100px">
            <el-button plain native-type="button" :disabled="disabledSend" class="send-button"
                       color="#8A8888" @click="sendLoginMsg">
              <span>{{ buttonName }}</span>
            </el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="medium" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="重置密码" :visible.sync="resetVisible" :center=true width="400px" :show-close=false
                 :close-on-click-modal=false :close-on-press-escape="false">
        <el-form :model="resetRuleForm" :rules="resetRules" ref="resetRuleForm">
          <el-form-item label="账号" label-width="100px" prop="account">
              <el-input v-model="resetRuleForm.account" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" label-width="100px" prop="password">
            <el-input type="password" v-model="resetRuleForm.password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" label-width="100px" prop="checkPwd">
            <el-input type="password" v-model="resetRuleForm.checkPwd" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="验证码" label-width="100px" prop="checkCode">
            <el-input v-model="resetRuleForm.checkCode" maxlength="6" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="" label-width="100px">
            <el-button plain native-type="button" :disabled="disabledSend" class="send-button"
                       color="#8A8888" @click="sendResetMsg">
              <span>{{ buttonName }}</span>
            </el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="medium" @click="resetPwdForm('resetRuleForm')">确 定</el-button>
          <el-button size="medium" @click="resetVisible=false;resetForm('resetRuleForm')">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import {doLogin, sendMsg, doReset, sendResetMsg, queryCPSConfig} from '@/api/request'
import crypto from '@/utils/crypto.js';

import backgroundImg from '@/assets/background.jpg'
import EventBus from "@/api/EventBus";
import {webConfig} from "@/api/config";

export default {
  name: 'login',
  data() {
      var validatePwd = (rule, value, callback) => {
          if (value === '') {
              callback(new Error('请再次输入密码'));
          } else if (value !== this.resetRuleForm.password) {
              callback(new Error('两次输入密码不一致!'));
          } else {
              callback();
          }
      };
    return {
      backgroundImg,
      activeName: 'first',
      dialogFormVisible: false,
      resetVisible: false,
      disabledSend: false,
      showSendText: true,
      buttonName: '获取验证码',
      time: 60,
      loginLoading: false,
      ruleForm: {
        password: '',
        account: '',
        checkCode: '',
        phone: ''
      },
      rules: {
        account: [
          {pattern: /^\w{3,20}$/, trigger: 'blur', message: '请输入正确的账号'},
          {required: true, message: '请输入账号'}
        ],
        password: [
          {pattern: /^.{6,18}$/, trigger: 'blur', message: '密码长度在6-18位之间'},
          {required: true, message: '请输入密码'}
        ]
      },
      resetRuleForm: {
            password: '',
            account: '',
            checkCode: '',
            checkPwd: '',
      },
      resetRules: {
        account: [
            {pattern: /^\w{3,20}$/, trigger: 'blur', message: '请输入正确的账号'},
            {required: true, message: '请输入账号'}
        ],
        password: [
            {pattern: /^.{6,18}$/, trigger: 'blur', message: '密码长度在6-18位之间'},
            {required: true, message: '请输入密码'}
        ],
        checkPwd: [
            { validator: validatePwd, trigger: 'blur' }
        ],
        checkCode: [
            {pattern: /^[1-9]{6}$/, trigger: 'blur', message: '请输入正确的验证码'},
            {required: true, message: '请输入验证码'}
        ]
      },
      cpsConfig: {},
    };
  },
  mounted() {
      this.initPage();
  },
  methods: {
    initPage() {
      this.cpsConfig = webConfig;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogFormVisible == true && !this.ruleForm.checkCode) {
            this.$alert("请输入验证码");
          } else {
            this.loginLoading = true;
            let params = {
              loginName: this.ruleForm.account,
              password: crypto.encrypt(this.ruleForm.password),
              checkCode: this.ruleForm.checkCode
            }
            doLogin(params).then(res => {
              this.loginLoading = false;
              if (res.data.success) {
                //需要二次验证
                if (res.data.data.needCheck) {
                  this.ruleForm.phone = res.data.data.phone;
                  this.dialogFormVisible = true;
                } else {
                  localStorage.setItem('token', res.data.data.token);
                  localStorage.setItem('userInfo', JSON.stringify(res.data.data));
                  this.dialogFormVisible = false;
                  this.$router.push({path: "/home"});
                }
              } else {
                this.$alert(res.data.error.message, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {

                  }
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    resetPwdForm(formName){
        this.$refs[formName].validate((valid) => {
            if (valid) {
                let params = {
                    resetName: this.resetRuleForm.account,
                    password: crypto.encrypt(this.resetRuleForm.password),
                    checkCode: this.resetRuleForm.checkCode,
                }
                doReset(params).then(res => {
                    if(res.data.success){
                        this.resetVisible = false;
                        this.$message.success(res.data.data);
                        this.resetForm(formName);
                    }else {
                        this.$message.error(res.data.error.message);
                    }
                })
            } else {
                return false;
            }
        });
    },
    sendLoginMsg() {
      let me = this;
      this.disabledSend = true
      let interval = window.setInterval(function () {
        me.buttonName = '（' + me.time + '秒）后重新发送';
        --me.time;
        if (me.time < 0) {
          me.buttonName = "重新发送";
          me.time = 60;
          me.disabledSend = false;
          window.clearInterval(interval);
        }
      }, 1000);

      sendMsg(this.ruleForm.phone).then(res => {
        if (res.data.success) {
          this.$message({
            message: '验证码发送成功',
            type: 'success'
          });
        } else {
          this.$alert(res.data.error.message, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    sendResetMsg(){
        let me = this;
        this.disabledSend = true
        let interval = window.setInterval(function () {
            me.buttonName = '（' + me.time + '秒）后重新发送';
            --me.time;
            if (me.time < 0) {
                me.buttonName = "重新发送";
                me.time = 60;
                me.disabledSend = false;
                window.clearInterval(interval);
            }
        }, 1000);

        sendResetMsg(this.resetRuleForm.account).then(res => {
            if (res.data.success) {
                this.$message({
                    message: '验证码发送成功',
                    type: 'success'
                });
            } else {
                this.$alert(res.data.error.message, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                });
            }
        });
    },
  }
}
</script>

<style scoped lang="scss">
.main-container {
  background: url("../../assets/login_bg.png");
  width: 100%;
  height: 100vh;
  //position: fixed;
  background-size: 100% 100%;
  overflow: hidden;
  
  .main-border {
    width: 450px;
    height: 650px;
    background-color: rgba(255, 255, 255, .2);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    box-shadow:inset 0 0 6px rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    text-align: center;
    color: black;
    padding: 20px 50px;
    
    position: absolute;
    top: 50%;
    left: 75%;
    margin-left: -225px;
    margin-top: -325px;
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    .el-divider--horizontal {
      margin: 14px 0;
    }

    .line-panel {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      font-size: 24px;
      line-height: 50px;
      width: fit-content;
      margin: 0 auto;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      span {
        margin-left: .5rem;
        font-size: 1.6rem;
        font-weight: 600;
      }
    }

    .form-border {
      width: 100%;
      text-align: left;
      
      /deep/ .el-input__inner {
        background-color: transparent;
        border: 1px solid #ef8942;
      }
      
      /deep/ .el-input__inner::placeholder{
        color: #888888;
      }
      
      /deep/ label {
        color: black;
      }

      .el-form-item {
        //margin-bottom: 0;
      }

      /deep/ .el-form-item__label {
        padding: 0 !important;
        font-weight: 600;
        font-size: 17px;
      }

      .button-div {
        text-align: center;
        width: 200px;
        margin: 30px auto 0;
        border: 1px solid white;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor: pointer;
        font-weight: 600;
        font-size: 17px;
      }

      .login-button {
        display: block;
        width: 200px;
        margin: 30px auto 0;
        font-weight: 600;
        font-size: 17px;
        color: black;
        background-color: rgba(0, 0, 0, 0);
        border: 2px solid black;
      }

      .reset-button{
          margin:0 auto;
          display: block;
          color: black;
          font-size: 10px;
      }
      .reset-button :hover{
          color: #409EFF;
      }
    }
  }
}
</style>
